document.addEventListener("DOMContentLoaded", function () {
  const faqWrapper = document.querySelector(".product-faq__content");
  const faqInformation = document.querySelector(".product-faq__container");
  const tableQuestion = document.querySelectorAll(".faq-table__question");

  tableQuestion.forEach((question, index, array) => {
    question.addEventListener("click", function () {
      closeAllTabs(array, index);
      toggleContent(question);
    });
  });

  function toggleContent(htmlElement) {
    const pointForIncrease = faqInformation.scrollHeight
    const heightParentElement = Number(faqWrapper.scrollHeight);
    const { parentElement, nextElementSibling } = htmlElement;
    const { scrollHeight } = nextElementSibling;
    const isOpen = parentElement.dataset.open === "false" ? true : false;

    nextElementSibling.style.maxHeight = isOpen ? scrollHeight * 2 + "px" : 0;
    parentElement.setAttribute("data-open", String(isOpen));
    faqWrapper.style.maxHeight = isOpen ? scrollHeight + heightParentElement + "px" : heightParentElement + "px";
  }

  function closeAllTabs(htmlCollection, currentIndex) {
    htmlCollection.forEach((element, index) => {
      if (currentIndex === index) return;
      const currentTab = element.closest(".faq-table__item");
      const currentContent = currentTab.querySelector(".faq-table__answer");
      const isOpenTab = currentTab.getAttribute("data-open") === "false" ? false : true;
      if (isOpenTab) {
        currentTab.setAttribute("data-open", "false");
        currentContent.style.maxHeight = 0;
      }
    });
  }
});
